import { Instant, LocalDate, LocalDateTime, ZoneId } from './datetime';
export const parseJSON = (x) => JSON.parse(x);
const zone = ZoneId.of(Intl.DateTimeFormat().resolvedOptions().timeZone);
export const parseInstant = (x) => Instant.parse(x);
export const parseInstantN = (x) => x ? parseInstant(x) : null;
export const parseLocalDateTime = (x) => x.endsWith('Z')
    ? Instant.parse(x).atZone(zone).toLocalDateTime()
    : x.includes('T')
        ? LocalDateTime.parse(x)
        : LocalDate.parse(x).atStartOfDay();
export const parseLocalDateTimeN = (x) => x ? parseLocalDateTime(x) : null;
export const parseLocalDate = (x) => LocalDate.parse(x);
export const parseLocalDateN = (x) => x ? parseLocalDate(x) : null;
export const base64DecodeUnicode = (s) => decodeURIComponent(atob(s).replace(/(.)/g, (_, p) => {
    let code = p.charCodeAt(0).toString(16).toUpperCase();
    if (code.length < 2) {
        code = `0${code}`;
    }
    return `%${code}`;
}));
export const base64UrlDecode = (s) => {
    let output = s.replace(/-/g, '+').replace(/_/g, '/');
    switch (output.length % 4) {
        case 0:
            break;
        case 2:
            output += "==";
            break;
        case 3:
            output += "=";
            break;
        default:
            throw new Error('base64 string is not of the correct length');
    }
    try {
        return base64DecodeUnicode(output);
    }
    catch (_a) {
        return atob(output);
    }
};
export function jwtDecode(token) {
    const [_, part] = token.split('.');
    let decoded;
    try {
        decoded = base64UrlDecode(part);
    }
    catch (e) {
        throw new Error(`Invalid Token: Invalid base64 (${e instanceof Error ? e.message : e})`);
    }
    try {
        return JSON.parse(decoded);
    }
    catch (e) {
        throw new Error(`Invalid Token: Invalid JSON (${e instanceof Error ? e.message : e})`);
    }
}
